import React from 'react';
import Icon from '../../components/Icon';
import Modal from 'react-modal';

Modal.setAppElement('#root');

const ForumHow = ({isOpen, onClose}) => {
  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} contentLabel="Example Modal">
      <div className="row align-items-center justify-content-between mb-4">
        <div className="col-auto">
          <div className="fw-bold font-4">Подсказка</div>
        </div>
        <div className="col-auto">
          <button className="btn p-2 font-2" onClick={onClose}>
            Закрыть <Icon name="times" />
          </button>
        </div>
      </div>
      <div className="overflow-auto pb-4">
        Создайте тему и задайте ваш вопрос. При необходимости можно отметить тегом
        <br />
        <br />
        После получения ответов можно отметить до трех человек знаком «спасибо»
        <br />
        <br />
        Затем закройте тему
        <br />
        <br />
        Темы автоматически закрываются через 30 дней, вне зависимости от получения ответа
      </div>
    </Modal>
  );
};

export default ForumHow;
